<template>
  <div class="gx-inline-select" :style="width ? { width: width + 'px' } : {}">
    <button
      class="gx-inline-select__btn"
      :style="{ height: compact ? 30 : 34, borderColor: open ? 'rgba(212,169,70,.45)' : 'rgba(212,169,70,.2)' }"
      @click="open = !open"
    >
      <span class="gx-inline-select__value">{{ value }}</span>
      <svg width="11" height="11" viewBox="0 0 11 11" fill="none" :style="{ transform: open ? 'rotate(180deg)' : 'none', transition: 'transform .2s' }">
        <path d="M2 4l3.5 3.5L9 4" stroke="currentColor" stroke-width="1.3" stroke-linecap="round" stroke-linejoin="round" />
      </svg>
    </button>
    <div v-if="open" class="gx-inline-select__panel">
      <button
        v-for="opt in options"
        :key="opt"
        class="gx-inline-select__opt"
        :style="{ background: opt === value ? 'rgba(212,169,70,.1)' : 'transparent', color: opt === value ? '#E8C778' : '#1A1A2E' }"
        @click="select(opt)"
        @mouseenter="$event.currentTarget.style.background = (opt !== value ? '#F0F2F8' : 'rgba(212,169,70,.1)')"
        @mouseleave="$event.currentTarget.style.background = (opt === value ? 'rgba(212,169,70,.1)' : 'transparent')"
      >{{ opt }}</button>
    </div>
  </div>
</template>

<script>
/**
 * 严格对照新版 ShopPages.tsx 的 InlineSelect 组件
 */
export default {
  name: 'InlineSelect',
  props: {
    value: { type: String, default: '' },
    options: { type: Array, default: () => [] },
    compact: { type: Boolean, default: false },
    width: { type: Number, default: 0 }
  },
  data() {
    return { open: false }
  },
  methods: {
    select(opt) {
      this.$emit('change', opt)
      this.open = false
    }
  }
}
</script>

<style scoped>
.gx-inline-select {
  position: relative;
  flex-shrink: 0;
}
.gx-inline-select__btn {
  display: flex;
  align-items: center;
  gap: 6px;
  width: 100%;
  box-sizing: border-box;
  padding: 0 10px;
  background: #FFFFFF;
  border: 1px solid;
  border-radius: 7px;
  cursor: pointer;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 12px;
  color: #1A1A2E;
  white-space: nowrap;
  transition: border .15s;
}
.gx-inline-select__value {
  overflow: hidden;
  text-overflow: ellipsis;
  white-space: nowrap;
}
.gx-inline-select__btn svg {
  color: #6A6A8A;
  flex-shrink: 0;
}
.gx-inline-select__panel {
  position: absolute;
  top: calc(100% + 4px);
  left: 0;
  min-width: 100%;
  border-radius: 9px;
  overflow: hidden;
  z-index: 300;
  background: #FFFFFF;
  border: 1px solid rgba(212, 169, 70, .22);
  box-shadow: 0 12px 36px rgba(0, 0, 0, .5);
}
.gx-inline-select__opt {
  width: 100%;
  padding: 8px 12px;
  text-align: left;
  border: none;
  cursor: pointer;
  font-family: 'Noto Sans SC', sans-serif;
  font-size: 13px;
  transition: background .15s;
  white-space: nowrap;
}
</style>
